<template>
  <div>
    <v-card>
      <v-card-title>
        Arqueos de Caja
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="green" fab small dark @click="_nuevo()">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <v-skeleton-loader v-if="loading" type="table"></v-skeleton-loader>
          <v-data-table
            :headers="encabezados"
            :items="listado"
            :search="search"
            v-else
          >
            <template v-slot:header="{ props: { headers } }">
              <thead>
                <tr>
                  <th :colspan="headers.length">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Ingrese busqueda"
                      single-line
                      hide-details
                    ></v-text-field>
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:item._id="{ item }">{{
              item._id.slice(-5)
            }}</template>
            <template v-slot:item.fechaAlta="{ item }">{{
              item.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm")
            }}</template>
            <template v-slot:item.acciones="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="irArqueo(item._id)"
              >mdi-eye</v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import axios from "axios" 
export default {
  name: "Arqueos_Listado",
  data() {
    return {
      encabezados: [
        {
          text: "Fecha y Hora",
          value: "fechaAlta",
        },
        { text: "Saldo", value: "saldo" },
        { text: "Cambio", value: "cambio" },
        {
          text: "Acciones",
          value: "acciones",
        },
      ],
      listado: [],
      search: '',
      loading: true
    };
  },
  methods: {
   async _obtenerArqueos() {
       this.loading = true
       try {
           const arqueos = await axios.get("/arqueos")
           this.listado = arqueos.data
       } catch (error) {
           console.log(error)
       }
       this.loading = false
   },
   irArqueo(_id) {
       this.$router.push(`/arqueos/${_id}`)
   },
    _nuevo() {
      this.$router.push(`/arqueos/nuevo`);
    },
  },
  created() {
      this._obtenerArqueos()
  }
};
</script>
